import React, { useState, useEffect } from 'react';

const ListaFiltros = (p) => {
    //genera un listado de inputs tipo select utilizando los parametros recibidos y utiliza la funcion recibida para actualizar los valores
    const filtrosKeys = p.keys;
    const filtros = p.filtros;
    const funcion = p.funcion;
    const values = p.values;
    const containerStyle = p.containerStyle ?? 'form-group bw-200 m-0 mb-1';
    return (
        <>
            {

                filtrosKeys.map((key, index) => {
                    return (
                        <div key={index} className={containerStyle}>
                            <label className='text-bold w-100 text-xs'>FILTRAR POR {key.toUpperCase()}</label>
                            <select className='form-select form-select-sm border shadow-sm round-m' name={key} value={values[key]} onChange={funcion}>
                                <option value=''>Seleccionar</option>
                                {
                                    filtros[key].map((reg, i) => {
                                        return <option key={i + "index"} value={key === 'semana' ? reg : reg.id}>{key === 'semana' ? reg : reg.nombre}</option>
                                    })
                                }
                            </select>
                        </div>
                    )
                })
            }
        </>

    )
}

export default ListaFiltros;